import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { deepCopy } from '@delon/util';
import { Subject, Observable, of } from 'rxjs';
import { distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { _HttpClient } from '@delon/theme';
import { DialogService } from '../../services/dialog.service';

export const varSelect = { label: '变量', value: 1 };
export const tagSelect = { label: '标签', value: 2 };
@Component({
  selector: 'app-condition',
  templateUrl: './condition.component.html',
  styleUrls: ['./condition.component.less'],
})
export class ConditionComponent implements OnInit, OnChanges {
  constructor(private dialogService: DialogService, public http: _HttpClient) {}
  conditionType = [varSelect, tagSelect];
  condition = {
    type: null,
    name: null,
    object: {},
    bindObj: {},
    value: null,
    min: null,
    max: null,
    isEdit: false
  };
  noEmpty = [];
  editIndex = -1;
  editTmp = null;
  isUpdate = null;
  @Input()
  conditions = [];

  @Input()
  sIndex = null;
  @Input()
  variableBinds = [];
  @Input()
  tagUrl: string;
  @Input()
  mode: 'edit' | 'view' = 'edit';
  tagMetaList$: Observable<any[]>; // 自动补全过滤
  tagMetaList = []; // 加载所有的标签库
  private searchTerms = new Subject<any>();

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    for (let i = 0; i < this.conditions.length; i++) {
      if (this.conditions[i].name === null || (this.conditions[i].value === null && this.conditions[i].max === null && this.conditions[i].min === null)) {
        this.conditions.splice(i, 1);
      }
    }
    this.processCondition();
  }

  /** 预处理 */
  processCondition() {
    this.noEmpty = this.conditions;
    this.loadTagInfos();
    this.conditions.forEach(c => {
      c.bindObj = c.object;
    });
    this.tagMetaList$ = this.searchTerms.pipe(
      // debounceTime(300), 异步去除抖动会引起样式问题
      distinctUntilChanged(),
      switchMap(param => of(this.tagMetaList.filter(meta => this.conditions.findIndex(cond => cond.type.value === 2 && cond.object.id === meta.id) < 0 && (meta.label.indexOf(param.value) >= 0 || !param.value || param.isClick)))),
      map(list => list),
    );
  }

  loadTagInfos() {
    if (this.mode === 'edit') {
      this.http.get(this.tagUrl).subscribe(data => {
        if (data.status === 0) {
          data.data.forEach((d, index: number, array) => {
            const tagMeta = {
              id: d.id,
              label: d.name,
              value: d.id,
              customerTagList: d.customerTagList,
              refControl: d.refControl,
            };
            this.tagMetaList.push(tagMeta);
            // 回显最新数据库值
            const bindTagMeta = this.conditions.find(bind => bind.type.value === 2 && tagMeta.id === bind.object.id);

            if (bindTagMeta) {
              bindTagMeta.object = deepCopy(tagMeta);
              bindTagMeta.bindObj = deepCopy(tagMeta);
              bindTagMeta.name = tagMeta.label;
            }
          });
        }
      });
    }
  }

  /**
   * 标签标量是否影藏
   */
  needVarTagHide(condition, obj) {
    if (condition.type.value === 1 && !obj.isRequired) {
      return true;
    }
    for (let cond of this.conditions) {
      if (obj === cond.object) {
        return true;
      }
    }
  }

  needVarTypeHide(type) {
    if (type.value === 1 && (!this.variableBinds || this.variableBinds.length === 0)) {
      return true;
    }

    return false;
  }

  /**
   * 变量操作
   */
  addConditon() {
    this.typeSelectChange();
    if (this.conditions.length >= 8) {
      this.dialogService.notification.error('执行条件', '最多可添加8个执行条件');
      return;
    }
    const cond = deepCopy(this.condition);
    cond.type = this.conditionType[1];
    this.conditions.push(cond);
    this.noEmpty = [...this.conditions];
    this.setEditTmpInfo(this.conditions.length - 1, false, deepCopy(cond));
  }

  loadTagMeta(condition, value, change) {
    this.searchTerms.next({ value, isClick: !change });
    if (change) {
      condition.object = {};
    }
  }

  typeChange(condition) {
    if (condition.type.value === 1 && this.variableBinds.findIndex(v => v.isRequired) < 0) {
      this.dialogService.notification.error('暂无可用变量', '非必填变量无法作为执行条件，请在当前业务类型中【添加变量】进行设置');
    }
  }
  /**
   * 类型选择的下拉框选项改变
   * - 如果变量用完了，类型中应该去除变量
   */
  typeSelectChange() {
    const totalVarCondition = this.variableBinds.filter(it => it.isRequired);
    const selectedVarCondition = this.conditions.filter(it => it.type && it.type.value === 1);
    if (totalVarCondition.length === selectedVarCondition.length && selectedVarCondition.length > 0) {
      this.conditionType = [tagSelect];
      return;
    }
    this.conditionType = [varSelect, tagSelect];
  }

  selectTagMeta(condition, meta) {
    condition.object = deepCopy(meta);
    condition.bindObj = deepCopy(meta);
    condition.name = condition.bindObj.label;
    condition.value = null;
    condition.min = null;
    condition.max = null;
  }

  selectVar(condition) {
    condition.bindObj = deepCopy(this.variableBinds.filter(w => condition.bindObj.id === w.id)[0]);
    console.log(condition.bindObj.name)
    condition.object = condition.bindObj;
    condition.name = condition.bindObj.name;
    condition.value = null;
    condition.min = null;
    condition.max = null;
  }

  editCondition(cIndex) {
    if (this.editIndex !== -1) {
      this.dialogService.notification.error('执行条件', '请先保存正在编辑的执行条件');
      return;
    }
    const condition = this.conditions[cIndex];

    condition.min = condition.min || condition.min === '0' ? Number(condition.min) : condition.min;
    condition.max = condition.max || condition.max === '0' ? Number(condition.max) : condition.max;
    condition.type = condition.type.value === 1 ? varSelect : tagSelect;
    this.setEditTmpInfo(cIndex, true, deepCopy(condition));
  }

  saveCondition(condition) {
    if (!condition.object.id) {
      this.dialogService.notification.error('执行条件', '请选择正确的条件名称');
      return;
    }

    if ((!condition.value || (condition.value instanceof Array && condition.value.length === 0)) && !condition.min && condition.min !== 0 && !condition.max && condition.max !== 0) {
      this.dialogService.notification.error('执行条件', '条件描述不能为空');
      return;
    }
    condition.min = condition.min || condition.min === 0 ? String(condition.min) : condition.min;
    condition.max = condition.max || condition.max === 0 ? String(condition.max) : condition.max;
    this.setEditTmpInfo(-1, null, null);
  }

  removeCondition(i) {
    if (this.editIndex !== -1) {
      this.dialogService.notification.error('执行条件', '请先保存正在编辑的执行条件');
      return;
    }
    this.conditions.splice(i, 1);
    this.noEmpty = [...this.conditions];
    this.setEditTmpInfo(-1, null, null);
  }

  cancelCondition(i) {

    if (!this.isUpdate) {
      this.conditions.splice(i, 1);
      this.noEmpty = [...this.conditions];
      this.setEditTmpInfo(-1, null, null);
    } else {
      this.editTmp.type = this.editTmp.type.value === 1 ? varSelect : tagSelect;
      const condition = this.editTmp;
      condition.min = condition.min || condition.min === '0' ? Number(condition.min) : condition.min;
      condition.max = condition.max || condition.max === '0' ? Number(condition.max) : condition.max;

      this.conditions[i] = condition;

      this.setEditTmpInfo(-1, null, null);
    }
  }

  setEditTmpInfo(editIndex, isUpdate, editTmp) {
    this.editIndex = editIndex;
    this.isUpdate = isUpdate;
    this.editTmp = editTmp;

    this.conditions.forEach((item, index) => {
      item.isEdit = index === editIndex
    })

  }

  limitMaxLength(values) {
    if (values && values.length > 0) {
      for (let i = 0; i < values.length; i++) {
        if (values[i].length > 15) {
          values[i] = values[i].substring(0, 15);
          this.dialogService.notification.error('执行条件', '若字符长度超过限制范围，则截取前15个字符。');
          return;
        }
      }
    }
  }
}
